module.exports = __webpack_public_path__ + "img/code.f6e008ba.png";